import { Icon, IconProps } from './Icon';

interface EmailIconProps extends IconProps {
  gradient?: {
    id: string;
    stops: { offset: string; color: string }[];
  };
}

export const EmailIcon = ({ color = '#5E6A81', gradient, ...props }: EmailIconProps) => (
  <Icon
    {...props}
    viewBox="0 0 24 24"
  >
    <defs>
      {gradient && (
        <linearGradient
          id={gradient.id}
          x1="80%"
          y1="20%"
          x2="20%"
          y2="80%"
        >
          {gradient.stops.map((stop, index) => (
            <stop
              key={index}
              offset={stop.offset}
              stopColor={stop.color}
            />
          ))}
        </linearGradient>
      )}
    </defs>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 18.9806H5C3.895 18.9806 3 18.0856 3 16.9806V7.01855C3 5.91355 3.895 5.01855 5 5.01855H19C20.105 5.01855 21 5.91355 21 7.01855V16.9816C21 18.0856 20.105 18.9806 19 18.9806V18.9806Z"
      stroke={gradient ? `url(#${gradient.id})` : color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M17 9L12 12L7 9"
      stroke={gradient ? `url(#${gradient.id})` : color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </Icon>
);
